import { render } from "./bigChooseSmall1.vue?vue&type=template&id=943d582a"
import script from "./bigChooseSmall1.vue?vue&type=script&lang=js"
export * from "./bigChooseSmall1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__